import MetaSeoModal from "./Components/MetaSeoModal";

export const components = {
  MetaSeoModal,
};
